
export type CategoryType = 
  | 'Salário' 
  | 'Renda Extra' 
  | 'Cartão de Crédito'
  | 'Compra Parcelada'
  | 'Pagamento de Fatura'
  | 'Investimento'
  | 'Pagamento fixo/mês'
  | 'Moradia'
  | 'Pessoal' 
  | 'Desenvolvimento' 
  | 'Transporte' 
  | 'Entretenimento'
  | 'Pets'
  | 'Final de semana'
  | 'Delivery'
  | 'Outros';

export interface Transaction {
  id: string;
  description: string;
  amount: number;
  type: 'income' | 'expense';
  category: CategoryType;
  date: string;
  cardId?: string;
  installmentId?: string; 
  wealthItemId?: string;
}

export interface CreditCard {
  id: string;
  name: string;
  limit: number;
  currentBill: number;
  closingDate: number; // Dia de fechamento
  dueDate: number;     // Dia de vencimento
}

export interface WealthItem {
  id: string;
  name: string;
  type: 'savings' | 'emergency';
  amount: number;
  targetAmount?: number;
}

export interface UserProfile {
  id: string;
  email: string;
  full_name: string;
  google_sheets_id?: string;
  // Assinatura e Segurança
  salt?: string;
  encryption_verify?: string;
  wrapped_key?: string;
  subscription_status?: string;
  subscription_expiry?: string;
  renewal_count?: number;
  is_blocked?: boolean;
}

export enum MainScreen {
  DASHBOARD,
  TRANSACTIONS,
  CARDS,
  REPORTS,
  WEALTH,
  PROFILE
}

// Fix: Adicionando o enum AuthScreen que é importado pelos componentes de Login e Register
export enum AuthScreen {
  LOGIN,
  REGISTER,
  FORGOT_PASSWORD
}
